/**
 * JobRun entity — mirrors `leviathan_master.job_runs`.
 * Produced automatically by the ETL scheduler; not directly created by users.
 */
import { z } from 'zod';
import { ISO8601Date, JobId, JobRunId, TenantId, } from '../primitives/index.js';
import { JobRunStatus, JobTriggerType } from '../enums/index.js';
export const JobRunSchema = z.object({
    id: JobRunId,
    jobId: JobId,
    tenantId: TenantId,
    status: JobRunStatus,
    triggerType: JobTriggerType,
    startedAt: ISO8601Date,
    completedAt: ISO8601Date.nullable(),
    rowsExtracted: z.coerce.number().int().nonnegative(),
    rowsTransformed: z.coerce.number().int().nonnegative(),
    rowsLoaded: z.coerce.number().int().nonnegative(),
    rowsRejected: z.coerce.number().int().nonnegative(),
    rowsProcessed: z.coerce.number().int().nonnegative(),
    durationMs: z.coerce.number().int().nonnegative().nullable(),
    errorMessage: z.string().nullable(),
    errorDetails: z.record(z.string(), z.unknown()).nullable(),
    operationResults: z.record(z.string(), z.unknown()).nullable(),
});
//# sourceMappingURL=job-run.js.map